import { render } from "./Clock.vue?vue&type=template&id=523368d2"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import exportComponent from "/home/drdilyor/workspace/minesweeper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__